const grade_6= {
    label: "Grade 6",
    subjects: {
  "applied_design_6": {
    "label": "Applied Design (Grade 6)",
    "topics": [
      { "value": "Understanding_Context", "label": "Understanding Context" },
      { "value": "defining", "label": "Defining" },
      { "value": "ideating", "label": "Ideating" },
      { "value": "prototyping", "label": "Prototyping" },
      { "value": "testing", "label": "Testing" },
      { "value": "making", "label": "Making" },
      { "value": "sharing", "label": "Sharing" },
      { "value": "applied_skills", "label": "Applied Skills" },
      { "value": "applied_technologies", "label": "Applied Technologies" }
    ],
    "competencies": {
      "core": [
      { "value": "Understanding_Context", "label": "Understanding Context" },
      { "value": "defining", "label": "Defining" },
      { "value": "ideating", "label": "Ideating" },
      { "value": "prototyping", "label": "Prototyping" },
      { "value": "testing", "label": "Testing" },
      { "value": "making", "label": "Making" },
      { "value": "sharing", "label": "Sharing" },
      { "value": "applied_skills", "label": "Applied Skills" },
      { "value": "applied_technologies", "label": "Applied Technologies" }
      ],
 
      "sub": {
        "applied_design": [
          /* -------------------- Defining -------------------- */
          {
            "value": "empathize_with_users",
            "label": "Empathize with potential users to find issues and uncover needs and potential design opportunities"
          },
          {
            "value": "choose_design_opportunity",
            "label": "Choose a design opportunity"
          },
          {
            "value": "identify_key_features_users",
            "label": "Identify key features or potential users and their requirements"
          },
          {
            "value": "identify_criteria_constraints",
            "label": "Identify criteria for success and any constraints"
          },

          /* -------------------- Ideating -------------------- */
          {
            "value": "generate_potential_ideas",
            "label": "Generate potential ideas and add to others’ ideas"
          },
          {
            "value": "screen_ideas",
            "label": "Screen ideas against criteria and constraints"
          },
          {
            "value": "evaluate_impacts_ethics",
            "label": "Evaluate personal, social, and environmental impacts and ethical considerations"
          },
          {
            "value": "choose_idea_to_pursue",
            "label": "Choose an idea to pursue"
          },
          {
            "value": "identify_use_information_sources",
            "label": "Identify and use sources of information"
          },

          /* -------------------- Prototyping -------------------- */
          {
            "value": "develop_plan_stages_resources",
            "label": "Develop a plan that identifies key stages and resources"
          },
          {
            "value": "explore_test_materials",
            "label": "Explore and test a variety of materials for effective use"
          },
          {
            "value": "construct_first_version",
            "label": "Construct a first version of the product or a prototype, making changes to tools, materials, and procedures as needed"
          },
          {
            "value": "record_iterations",
            "label": "Record iterations of prototyping"
          },

          /* -------------------- Testing -------------------- */
          {
            "value": "test_first_version",
            "label": "Test the first version of the product or the prototype"
          },
          {
            "value": "gather_peer_user_expert_feedback",
            "label": "Gather peer, user, and/or expert feedback and inspiration"
          },
          {
            "value": "make_changes_troubleshoot_test",
            "label": "Make changes, troubleshoot, and test again"
          },

          /* -------------------- Making -------------------- */
          {
            "value": "identify_use_tools_materials",
            "label": "Identify and use appropriate tools, technologies, and materials for production"
          },
          {
            "value": "make_production_plan",
            "label": "Make a plan for production that includes key stages, and carry it out, making changes as needed"
          },
          {
            "value": "minimize_waste",
            "label": "Use materials in ways that minimize waste"
          },

          /* -------------------- Sharing -------------------- */
          {
            "value": "decide_sharing",
            "label": "Decide on how and with whom to share their product"
          },
          {
            "value": "demonstrate_product_process",
            "label": "Demonstrate their product and describe their process, using appropriate terminology and providing reasons for their selected solution and modifications"
          },
          {
            "value": "evaluate_against_criteria",
            "label": "Evaluate their product against their criteria and explain how it contributes to the individual, family, community, and/or environment"
          },
          {
            "value": "reflect_on_design_thinking",
            "label": "Reflect on their design thinking and processes, and evaluate their ability to work effectively both as individuals and collaboratively in a group, including their ability to share and maintain an efficient co-operative workspace"
          },
          {
            "value": "identify_new_design_issues",
            "label": "Identify new design issues"
          }
        ],

        /* -------------------- Applied Skills -------------------- */
        "applied_skills": [
          {
            "value": "awareness_safety_procedures",
            "label": "Demonstrate an awareness of precautionary and emergency safety procedures in both physical and digital environments"
          },
          {
            "value": "identify_evaluate_skills",
            "label": "Identify and evaluate the skills and skill levels needed, individually or as a group, in relation to a specific task, and develop them as needed"
          }
        ],

        /* -------------------- Applied Technologies -------------------- */
        "applied_technologies": [
          {
            "value": "select_learn_technologies",
            "label": "Select, and as needed learn about, appropriate tools and technologies to extend their capability to complete a task"
          },
          {
            "value": "identify_impacts_of_technology",
            "label": "Identify the personal, social, and environmental impacts, including unintended negative consequences, of the choices they make about technology use"
          },
          {
            "value": "identify_land_resource_culture_influence",
            "label": "Identify how the land, natural resources, and culture influence the development and use of tools and technologies"
          }
        ]
      }
    }
  }

,
  "arts_6": {
    "label": "Arts Education (Grade 6)",
    topics: [
        { value: "Expanding and Creating", label: "Expanding and Creating" },
        { value: "reasoning_reflecting", label: "Reasoning and Reflecting" },
        { value: "communicating_documenting", label: "Communicating and Documenting" },
        // { value: "connecting_expanding", label: "Connecting and Expanding" }
      ],
      competencies: {
        core: [
          { value: "Exploring", label: "Expanding and Creating" },
          { value: "Reasoning", label: "Reasoning and Reflecting" },
          { value: "Communicating", label: "Communicating and Documenting" },
          // { value: "Connecting", label: "Connecting and Expanding" }
        ],

      "sub": {
        "exploring_creating": [
          {
            "value": "select_apply_combine_elements_grade6",
            "label": "Intentionally select, apply, combine, and arrange artistic elements, processes, materials, movements, technologies, tools, techniques, and environments in art making"
          },
          {
            "value": "create_artistic_works_grade6",
            "label": "Create artistic works collaboratively and as an individual using ideas inspired by imagination, inquiry, experimentation, and purposeful play"
          },
          {
            "value": "explore_identity_place_culture_society_grade6",
            "label": "Explore relationships between identity, place, culture, society, and belonging through the arts"
          }
        ],

        "reasoning_reflecting": [
          {
            "value": "understand_contexts_arts_grade6",
            "label": "Demonstrate an understanding and appreciation of personal, social, cultural, historical, and environmental contexts in relation to the arts"
          },
          {
            "value": "research_describe_evaluate_artists_grade6",
            "label": "Research, describe, interpret, and evaluate how artists use processes, materials, movements, technologies, tools, techniques, and environments in the arts"
          },
          {
            "value": "develop_refine_ideas_skills_grade6",
            "label": "Develop and refine ideas, processes, and technical skills in a variety of art forms to improve the quality of artistic creations"
          },
          {
            "value": "reflect_understand_artist_intentions_grade6",
            "label": "Reflect on works of art and creative processes to understand artists’ intentions"
          },
          {
            "value": "interpret_using_other_learning_grade6",
            "label": "Interpret creative works using knowledge and skills from various areas of learning"
          }
        ],

        "communicating_documenting": [
          {
            "value": "interpret_communicate_symbols_grade6",
            "label": "Interpret and communicate ideas using symbols and elements to express meaning through the arts"
          },
          {
            "value": "take_creative_risks_grade6",
            "label": "Take creative risks to express feelings, ideas, and experiences"
          },
          {
            "value": "express_feelings_ideas_experiences_grade6",
            "label": "Express feelings, ideas, and experiences through the arts"
          },
          {
            "value": "describe_interpret_respond_art_grade6",
            "label": "Describe, interpret, and respond to works of art and explore artists’ intent"
          }
        ],

        "connecting_expanding": [
          {
            "value": "examine_arts_wider_world_grade6",
            "label": "Examine relationships between the arts and the wider world"
          },
          {
            "value": "adapt_skills_new_contexts_grade6",
            "label": "Adapt learned skills, understandings, and processes for use in new contexts and for different purposes and audiences"
          },
          {
            "value": "experience_document_present_grade6",
            "label": "Experience, document, and present creative works in a variety of ways"
          },
          {
            "value": "demonstrate_sophisticated_application_grade6",
            "label": "Demonstrate increasingly sophisticated application and/or engagement of curricular content"
          }
        ]
      }
    }
  }
,

career_education_6: {
        label: 'Career Education (Grade 6)',
        topics: [],
        competencies: {
          core: [
            { value: 'examine', label: 'Examine' },
            { value: 'interact', label: 'Interact' },
            { value: 'experience', label: 'Experience' },
            { value: 'initiate', label: 'Initiate' },
            { value: 'share', label: 'Share' }
          ],
          sub: {
            examine: [
              { value: 'recognize_their_personal_preferences_skills_strengths_and_abilities', label: 'Recognize their personal preferences, skills, strengths, and abilities and connect them to possible career choices' },
              { value: 'question_self_and_others_about_the_reciprocal_relationship', label: 'Question self and others about the reciprocal relationship between self and community' }
            ],
            interact: [
              { value: 'appreciate_the_importance_of_respect_inclusivity_and_other_positive_behaviours', label: 'Appreciate the importance of respect, inclusivity, and other positive behaviours in diverse, collaborative learning, and work environments' },
              { value: 'recognize_the_influence_of_peers_family_and_communities', label: 'Recognize the influence of peers, family, and communities on career choices and attitudes toward work' }
            ],
            experience: [
              { value: 'appreciate_the_value_of_new_experiences', label: 'Appreciate the value of new experiences, innovative thinking, and risk taking in broadening their career options' },
              { value: 'explore_volunteer_opportunities', label: 'Explore volunteer opportunities and other new experiences outside school and recognize their value in career development' },
              { value: 'apply_project_management_skills', label: 'Apply project management skills to support career development' }
            ],
            initiate: [
              { value: 'set_realistic_short_and_longer_term_learning_goals', label: 'Set realistic short- and longer-term learning goals, define a path, and monitor progress' },
              { value: 'demonstrate_leadership_skills', label: 'Demonstrate leadership skills through collaborative activities in the school and community' },
              { value: 'demonstrate_safety_skills', label: 'Demonstrate safety skills in an experiential learning environment' },
              { value: 'use_entrepreneurial_and_innovative_thinking', label: 'Use entrepreneurial and innovative thinking to solve problems' }
            ],
            share: [
              { value: 'examine_the_importance_of_service_learning', label: 'Examine the importance of service learning and the responsibility of individuals to contribute to the community and the world' },
              { value: 'question_self_and_others_about_how_their_personal_public_identity', label: 'Question self and others about how their personal public identity can have both positive and negative consequences' }
            ]
          }
        }
      },
  "english_6": {
    "label": "English Language Arts (Grade 6)",
    "topics": [
      { "value": "comprehend_connect", "label": "Comprehend and Connect (Reading, Listening, Viewing)" },
      { "value": "create_communicate", "label": "Create and Communicate (Writing, Speaking, Representing)" }
    ],
    "competencies": {
      "core": [
        { "value": "comprehend_connect", "label": "Comprehend and Connect (reading, listening, viewing)" },
        { "value": "create_communicate", "label": "Create and Communicate (writing, speaking, representing)" }
      ],
      "sub": {
        "comprehend_connect": [
          {
            "value": "access_info_evaluate",
            "label": "Access information and ideas for diverse purposes from a variety of sources and evaluate their relevance, accuracy, and reliability (Grade 6–9)"
          },
          {
            "value": "apply_strategies_comprehend",
            "label": "Apply appropriate strategies to comprehend written, oral, and visual texts, guide inquiry, and extend thinking (Grade 6–9)"
          },
          {
            "value": "synthesize_ideas_sources",
            "label": "Synthesize ideas from a variety of sources to build understanding (Grade 5–9)"
          },
          {
            "value": "recognize_text_features_genres",
            "label": "Recognize and appreciate how different features, forms, and genres of texts reflect different purposes, audiences, and messages (Grade 6–9)"
          },
          {
            "value": "think_critically_creatively",
            "label": "Think critically, creatively, and reflectively to explore ideas within, between, and beyond texts (Grade 6–9)"
          },
          {
            "value": "identify_personal_social_cultural_context",
            "label": "Recognize and identify the role of personal, social, and cultural contexts, values, and perspectives in texts (Grade 6–9)"
          },
          {
            "value": "recognize_language_identity",
            "label": "Recognize how language constructs personal, social, and cultural identity (Grade 6–9)"
          },
          {
            "value": "construct_personal_connections",
            "label": "Construct meaningful personal connections between self, text, and world (Grade 6–9)"
          },
          {
            "value": "respond_text_personal_creative_critical",
            "label": "Respond to text in personal, creative, and critical ways (Grade 6–9)"
          },
          {
            "value": "explain_literary_elements_devices",
            "label": "Understand or explain how literary elements, techniques, and devices enhance and shape meaning (Grade 6–9)"
          },
          {
            "value": "recognize_text_structures",
            "label": "Recognize an increasing range of text structures and how they contribute to meaning (Grade 6–9)"
          },
          {
            "value": "appreciate_fp_story_role",
            "label": "Recognize and appreciate the role of story, narrative, and oral tradition in expressing First Peoples perspectives, values, beliefs, and points of view (Grade 6–9)"
          },
          {
            "value": "fp_protocols_ownership",
            "label": "Develop an awareness of the protocols, ownership, and diversity within and across First Peoples texts (Grade 8–9)"
          },
          {
            "value": "influence_of_place_texts",
            "label": "Recognize the influence of place in First Peoples and other Canadian texts (Grade 6–9)"
          }
        ],

        "create_communicate": [
          {
            "value": "exchange_ideas_viewpoints",
            "label": "Exchange ideas and viewpoints to build shared understanding and extend thinking (Grade 6–9)"
          },
          {
            "value": "writing_design_processes_6_9",
            "label": "Use writing and design processes to plan, develop, and create engaging and meaningful literary and informational texts for a variety of purposes and audiences (Grade 6–9)"
          },
          {
            "value": "assess_refine_texts",
            "label": "Assess and refine texts to improve their clarity, effectiveness, and impact according to purpose, audience, and message (Grade 6–9)"
          },
          {
            "value": "use_canadian_conventions",
            "label": "Use an increasing repertoire of conventions of Canadian spelling, grammar, and punctuation (Grade 6–9)"
          },
          {
            "value": "oral_storytelling_processes",
            "label": "Use and experiment with oral storytelling processes (Grade 6–9)"
          },
          {
            "value": "select_features_forms_genres",
            "label": "Select and use appropriate features, forms, and genres according to audience, purpose, and message (Grade 6–9)"
          },
          {
            "value": "transform_ideas_original_texts",
            "label": "Transform ideas and information to create original texts (Grade 4–9)"
          },
          {
            "value": "express_opinion_support_evidence",
            "label": "Express an opinion and support it with credible evidence (Grade 9 emphasis)"
          }
        ]
      }
    }
  }

,
   
 "math_6": {
    "label": "Mathematics (Grade 6)",
"topics": [
      { "value": "reasoning_analyzing", "label": "Reasoning and Analyzing" },
      { "value": "understanding_solving", "label": "Understanding and Solving" },
      { "value": "communicating_representing", "label": "Communicating and Representing" },
      { "value": "connecting_reflecting", "label": "Connecting and Reflecting" }
    ],

    "competencies": {
      "core": [
        { "value": "reasoning_analyzing", "label": "Reasoning and Analyzing" },
        { "value": "understanding_solving", "label": "Understanding and Solving" },
        { "value": "communicating_representing", "label": "Communicating and Representing" },
        { "value": "connecting_reflecting", "label": "Connecting and Reflecting" }
      ],

      "sub": {
        "reasoning_analyzing": [
          {
            "value": "use_logic_patterns_solve_puzzles_6_9",
            "label": "Use logic and patterns to solve puzzles and play games"
          },
          {
            "value": "reason_analyze_apply_math_ideas_6_9",
            "label": "Use reasoning and logic to explore, analyze, and apply mathematical ideas"
          },
          {
            "value": "estimate_reasonably_6_9",
            "label": "Estimate reasonably"
          },
          {
            "value": "mental_math_strategies_6_9",
            "label": "Demonstrate and apply mental math strategies"
          },
          {
            "value": "use_tools_technology_patterns_6_9",
            "label": "Use tools or technology to explore and create patterns and relationships, and test conjectures"
          }
        ],

        "understanding_solving": [
          {
            "value": "model_mathematics_context_6_9",
            "label": "Model mathematics in contextualized experiences"
          },
          {
            "value": "apply_multiple_problem_solving_strategies_6_9",
            "label": "Apply multiple strategies to solve problems in both abstract and contextualized situations"
          },
          {
            "value": "demonstrate_math_understanding_6_9",
            "label": "Develop, demonstrate, and apply mathematical understanding through play, inquiry, and problem solving"
          },
          {
            "value": "visualize_explore_math_concepts_6_9",
            "label": "Visualize to explore mathematical concepts"
          },
          {
            "value": "problem_solving_local_culture_6_9",
            "label": "Engage in problem-solving experiences connected to place, story, cultural practices, and perspectives relevant to local First Peoples communities, the local community, and other cultures"
          }
        ],

        "communicating_representing": [
          {
            "value": "use_math_vocabulary_discussions_6_9",
            "label": "Use mathematical vocabulary and language to contribute to mathematical discussions"
          },
          {
            "value": "explain_justify_math_ideas_6_9",
            "label": "Explain and justify mathematical ideas and decisions"
          },
          {
            "value": "communicate_math_thinking_6_9",
            "label": "Communicate mathematical thinking in many ways"
          },
          {
            "value": "represent_math_ideas_6_9",
            "label": "Represent mathematical ideas in concrete, pictorial, and symbolic forms"
          }
        ],

        "connecting_reflecting": [
          {
            "value": "reflect_math_thinking_6_9",
            "label": "Reflect on mathematical thinking"
          },
          {
            "value": "connect_math_concepts_6_9",
            "label": "Connect mathematical concepts to each other and to other areas and personal interests"
          },
          {
            "value": "use_math_arguments_support_choices_6_9",
            "label": "Use mathematical arguments to support personal choices"
          },
          {
            "value": "incorporate_first_peoples_perspectives_6_9",
            "label": "Incorporate First Peoples worldviews and perspectives to make connections to mathematical concepts"
          }
        ]
      }
    }
  }
,

"phe_6": {
    "label": "Physical and Health Education (Grade 6)",
   "topics": [
      { "value": "physical_literacy", "label": "Physical Literacy" },
      { "value": "healthy_active_living", "label": "Healthy and Active Living" },
      { "value": "social_community_health", "label": "Social and Community Health" },
      { "value": "mental_well_being", "label": "Mental Well-Being" }
    ],

    "competencies": {
      "core": [
        { "value": "physical_literacy", "label": "Physical Literacy" },
        { "value": "healthy_active_living", "label": "Healthy and Active Living" },
        { "value": "social_community_health", "label": "Social and Community Health" },
        { "value": "mental_well_being", "label": "Mental Well-Being" }
      ],

      "sub": {
        "physical_literacy": [
          {
            "value": "refine_apply_movement_skills_6",
            "label": "Refine and apply fundamental movement skills in a variety of physical activities and environments (6–7)"
          },
          {
            "value": "apply_movement_concepts_strategies_6",
            "label": "Apply movement concepts and strategies in different physical activities (3–6)"
          },
          {
            "value": "safety_fair_play_leadership_6",
            "label": "Develop and demonstrate safety, fair play, and leadership in physical activities (K–9)"
          },
          {
            "value": "identify_preferred_activities_6",
            "label": "Identify and describe preferred types of physical activity (4–9)"
          }
        ],

        "healthy_active_living": [
          {
            "value": "participate_daily_activity_6",
            "label": "Participate daily in physical activity at moderate to vigorous intensity levels (K–6)"
          },
          {
            "value": "healthy_eating_relationship_health_6",
            "label": "Describe the relationship between healthy eating and overall health (4–6)"
          },
          {
            "value": "healthy_eating_strategies_6",
            "label": "Explore strategies for making healthy eating choices (3–6)"
          },
          {
            "value": "personal_healthy_living_strategies_6",
            "label": "Explore and describe strategies for pursuing personal healthy-living goals (4–6)"
          },
          {
            "value": "factors_influencing_choices_6",
            "label": "Identify factors influencing personal healthy-living choices"
          }
        ],

        "social_community_health": [
          {
            "value": "discrimination_stereotyping_bullying_6",
            "label": "Describe and assess strategies for responding to discrimination, stereotyping, and bullying (4–7)"
          },
          {
            "value": "outdoor_activities_community_connection_6",
            "label": "Explain how participation in outdoor activities supports connections with the community and environment (6–7)"
          },
          {
            "value": "promote_safe_caring_environments_6",
            "label": "Describe and apply strategies for promoting safe and caring environments (4–6)"
          }
        ],

        "mental_well_being": [
          {
            "value": "strategies_promote_mental_wellbeing_6",
            "label": "Describe and assess strategies for promoting mental well-being (4–6)"
          },
          {
            "value": "factors_influencing_self_identity_6",
            "label": "Describe factors influencing self-identity (4–7)"
          },
          {
            "value": "manage_mental_wellbeing_substance_6",
            "label": "Apply strategies for managing problems related to mental well-being and substance use (6–8)"
          },
          {
            "value": "manage_changes_puberty_6",
            "label": "Explore and describe strategies for managing changes during puberty"
          }
        ]
      }
    }
  },


      science_6: {
        label: "Science (Grade 6)",
        topics: [
          { value: "ecosystems", label: "Ecosystems" },
          { value: "forces_motion", label: "Forces and Motion" },
          { value: "matter_energy", label: "Matter and Energy" }
        ],
        competencies: {
          core: [
            { value: "questioning_predicting", label: "Questioning and Predicting" },
            { value: "planning_conducting", label: "Planning and Conducting" },
            { value: "processing_analyzing", label: "Processing and Analyzing Data and Information" },
            { value: "evaluating", label: "Evaluating" },
            { value: "applying_innovating", label: "Applying and Innovating" },
            { value: "communicating", label: "Communicating" }
          ],
          sub: {
            questioning_predicting: [
              { value: "sustained_curiosity", label: "Demonstrate a sustained curiosity about a scientific topic or problem of personal interest" },
              { value: "make_observations", label: "Make observations in familiar or unfamiliar contexts" },
              { value: "identify_questions", label: "Identify questions to answer or problems to solve through scientific inquiry" },
              { value: "predict_findings", label: "Make predictions about the findings of their inquiry" }
            ],

            planning_conducting: [
              { value: "plan_investigations", label: "With support, plan appropriate investigations to answer their questions or solve problems" },
              { value: "variables_fair_test", label: "Decide which variable should be changed and measured for a fair test" },
              { value: "choose_data", label: "Choose appropriate data to collect" },
              { value: "use_equipment_safely", label: "Use equipment and materials safely, identifying potential risks" }
            ],

            processing_analyzing: [
              { value: "represent_data_methods", label: "Construct and use a variety of methods, including tables, graphs, and digital technologies, to represent patterns or relationships in data" },
              { value: "identify_patterns", label: "Identify patterns and connections in data" },
              { value: "compare_with_predictions", label: "Compare data with predictions and develop explanations for results" }
            ],

            evaluating: [
              { value: "evaluate_fair_tests", label: "Evaluate whether investigations were fair tests" },
              { value: "sources_of_error", label: "Identify possible sources of error" },
              { value: "improve_methods", label: "Suggest improvements to investigation methods" },
              { value: "identify_assumptions", label: "Identify assumptions in secondary sources" },
              { value: "appreciate_evidence", label: "Demonstrate understanding and appreciation of evidence" },
              { value: "social_ethical_environmental", label: "Identify social, ethical, and environmental implications of investigations" }
            ],

            applying_innovating: [
              { value: "care_self_community", label: "Contribute to care for self, others, and community through personal or collaborative approaches" },
              { value: "cooperative_design", label: "Co-operatively design projects" },
              { value: "apply_learning", label: "Transfer and apply learning to new situations" },
              { value: "generate_new_ideas", label: "Generate and introduce new or refined ideas when problem solving" }
            ],

            communicating: [
              { value: "communicate_variety_ways", label: "Communicate ideas, explanations, and processes in a variety of ways" },
              { value: "express_reflect_place", label: "Express and reflect on personal, shared, or others’ experiences of place" }
            ]
          }
        }
      },
      core_french_6: {
        label: 'Core French',
        topics: [],
        competencies: {
          core: [
            { value: 'thinking_and_communicating', label: 'Thinking and Communicating' },
            { value: 'personal_and_social_awareness', label: 'Personal and Social Awareness' }
          ],
          sub: {
            thinking_and_communicating: [
              { value: 'recognize_letter_patterns_pronunciation', label: 'Begin to recognize the relationships between French letter patterns and pronunciation' },
              { value: 'comprehend_key_information_details', label: 'Comprehend key information and some details in slow, clear speech and other simple texts' },
              { value: 'comprehend_simple_stories', label: 'Comprehend simple stories' },
              { value: "use_various_strategies", label: "Use various strategies to support communication" },
              { value: "seek_clarification", label: "Seek clarification of meaning" },
              { value: 'recognize_intonation_meaning', label: 'Recognize the relationships between intonation and meaning' },
              { value: 'respond_to_questions_commands', label: 'Respond to questions, simple commands, and instructions' },
              { value: 'exchange_ideas_information', label: 'Exchange ideas and information using complete sentences, both orally and in writing' },
              { value: 'express_and_comprehend_others', label: 'Express themselves and comprehend others through various modes of presentation' }
            ],
            personal_and_social_awareness: [
              { value: 'explore_francophone_communities', label: 'Explore Francophone communities across Canada' },
              { value: 'explore_connections_first_peoples', label: 'Explore connections between First Peoples communities and the French language' },
              { value: 'explore_francophone_cultural_festival', label: 'Explore a Francophone cultural festival or celebration in Canada' }
            ]
          }
        }
      },
     
      

      
  "social_studies_6": {
    "label": "Social Studies (Grade 6)",
   "topics": [
      { "value": "inquiry", "label": "Inquiry" },
      { "value": "significance", "label": "Significance" },
      { "value": "evidence", "label": "Evidence" },
      { "value": "continuity_change", "label": "Continuity and Change" },
      { "value": "cause_consequence", "label": "Cause and Consequence" },
      { "value": "perspective", "label": "Perspective" },
      { "value": "ethical_judgement", "label": "Ethical Judgement" }
    ],

    "competencies": {
      "core": [
        { "value": "inquiry", "label": "Inquiry" },
        { "value": "significance", "label": "Significance" },
        { "value": "evidence", "label": "Evidence" },
        { "value": "continuity_change", "label": "Continuity and Change" },
        { "value": "cause_consequence", "label": "Cause and Consequence" },
        { "value": "perspective", "label": "Perspective" },
        { "value": "ethical_judgement", "label": "Ethical Judgement" }
      ],
      "sub": {
        "inquiry": [
          {
            "value": "inquiry_process_ss5_6",
            "label": "Use Social Studies inquiry processes and skills to ask questions; gather, interpret, and analyze ideas; and communicate findings and decisions"
          },
          {
            "value": "develop_plan_action_ss5_6",
            "label": "Develop a plan of action to address a selected problem or issue"
          }
        ],

        "significance": [
          {
            "value": "construct_arguments_significance_ss5_6",
            "label": "Construct arguments defending the significance of individuals/groups, places, events, or developments"
          }
        ],

        "evidence": [
          {
            "value": "ask_corroborate_conclude_sources_ss5_6",
            "label": "Ask questions, corroborate inferences, and draw conclusions about the content and origins of a variety of sources, including mass media"
          }
        ],

        "continuity_change": [
          {
            "value": "sequence_recognize_continuity_change_ss5_6",
            "label": "Sequence objects, images, or events, and recognize the positive and negative aspects of continuities and changes in the past and present"
          }
        ],

        "cause_consequence": [
          {
            "value": "differentiate_causes_consequences_ss5_6",
            "label": "Differentiate between short- and long-term causes, and intended and unintended consequences, of events, decisions, or developments"
          }
        ],

        "perspective": [
          {
            "value": "take_stakeholders_perspectives_ss5_6",
            "label": "Take stakeholders’ perspectives on issues, developments, or events by making inferences about their beliefs, values, and motivations"
          }
        ],

        "ethical_judgement": [
          {
            "value": "make_ethical_judgments_responses_ss5_6",
            "label": "Make ethical judgments about events, decisions, or actions that consider the conditions of a particular time and place, and assess appropriate ways to respond"
          }
        ]
      }
    }
  },
  
  
 





    }
  }
  export default grade_6;